import { render, staticRenderFns } from "./AlternativePopup.vue?vue&type=template&id=04d03fef&"
import script from "./AlternativePopup.vue?vue&type=script&lang=js&"
export * from "./AlternativePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports